import * as dto from '@epicuro-next/data/baskets-dto';
import {
  BasketRowsGroup,
  BasketRowsGroupType,
} from 'graphql-api/baskets-api-interfaces';

import {
  getNestedObjects,
  GetRowsFn,
  GroupingFn,
  groupItemsByBrand,
  Mappings,
} from '../mappings';

/**
 * Top level grouping by brand.
 */
export function groupByBrand(
  items: dto.Item[],
  maps: Mappings,
  groupFn?: GroupingFn,
  getRowsFn?: GetRowsFn,
): BasketRowsGroup[] {
  const brandItemsMap = groupItemsByBrand(items);

  return Object.keys(brandItemsMap).map((brandId) => {
    const brandItems = brandItemsMap[brandId];
    const brand = Object.values(maps.products).find(
      (product) => product.brand.brandId === brandId,
    )?.brand;
    const nested = getNestedObjects(brandItems, maps, groupFn, getRowsFn);

    return {
      id: brandId,
      type: BasketRowsGroupType.Brand,
      title: brand?.name ?? brandId,
      ...nested,
    };
  });
}
